import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import View from "./View";

export default class Views extends PureComponent {
  static propTypes = {
    views: PropTypes.shape({
      large: PropTypes.arrayOf(PropTypes.string),
      small: PropTypes.arrayOf(PropTypes.string)
    })
  };
  state = {
    currentIndex: 0
  };
  changeCurrentIndex = (index) => {
    return () => {
      const {
        views: {large}
      } = this.props;
      const end = large && large.length;
      if (index < 0) {
        this.setState({
          currentIndex: end + index
        });
      } else if (index >= end) {
        this.setState({
          currentIndex: index - end
        });
      } else {
        this.setState({
          currentIndex: index
        });
      }
    };
  };
  render() {
    const {
      views: {large, small}
    } = this.props;
    const {currentIndex} = this.state;
    const filterLargeViews = large.filter((i) => !!i);
    const filterSmallViews = small.filter((i) => !!i);
    return (
      <div className="views">
        <div className="views__main">
          {filterLargeViews && filterLargeViews.length > 1 && (
            <button
              className="views__control views__control-left"
              onClick={this.changeCurrentIndex(currentIndex - 1)}
            >
              <i className="fas fa-chevron-left" />
            </button>
          )}
          {filterLargeViews && filterLargeViews.length > 0 && (
            <View mode="large" src={filterLargeViews[currentIndex]} />
          )}
          {filterLargeViews && filterLargeViews.length > 1 && (
            <button
              className="views__control views__control-right"
              onClick={this.changeCurrentIndex(currentIndex + 1)}
            >
              <i className="fas fa-chevron-right" />
            </button>
          )}
        </div>
        {filterSmallViews.length > 1 && (
          <div className="views__nav">
            {filterSmallViews.map((src, index) => {
              return (
                <div
                  key={src}
                  className={`views__nav-item${
                    currentIndex === index ? ` views__nav-item_active` : ``
                  }`}
                >
                  <View
                    mode="small"
                    src={src}
                    handleClick={this.changeCurrentIndex(index)}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}
